import type { ComboboxItemWithValue } from "@replo/design-system/components/combobox/Combobox";

import React from "react";

import {
  Combobox,
  ComboboxTriggerButton,
} from "@replo/design-system/components/combobox/Combobox";
import { useFontWeightOptions } from "@v2/features/modifiers/hooks/useFontWeightOptions";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

interface FontWeightSelectorProps {
  fontWeight: number | null;
  onSelect: (fontWeight: number | null) => void;
  placeholder: string;
  fontFamily: string | null;
}

const FontWeightSelector: React.FC<FontWeightSelectorProps> = ({
  fontWeight,
  onSelect,
  placeholder,
  fontFamily,
}) => {
  const [selectedFontWeight, setSelectedFontWeight] = useOverridableState(
    fontWeight,
    onSelect,
  );

  const { options, displayOption, isDisabled } = useFontWeightOptions(
    fontFamily,
    selectedFontWeight,
  );

  const items: ComboboxItemWithValue[] = options.map((weight) => ({
    value: weight.value,
    label: weight.label,
  }));

  const selectedItem =
    items.find((item) => item.value === selectedFontWeight?.toString()) ?? null;

  const displayTitle = displayOption?.label ?? placeholder;

  return (
    <div className="w-full overflow-hidden">
      <Combobox
        items={items}
        value={selectedItem}
        onValueChange={(item) => {
          if (item) {
            setSelectedFontWeight(Number(item.value));
          }
        }}
        isItemEqualToValue={(a, b) => a.value === b.value}
        trigger={
          <ComboboxTriggerButton
            className="w-full"
            isPlaceholder={!displayOption}
            disabled={isDisabled}
          >
            {displayTitle}
          </ComboboxTriggerButton>
        }
        triggerAsChild
        placeholder="Search..."
        UNSAFE_className="w-[180px]"
      />
    </div>
  );
};

export default FontWeightSelector;
